import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { HomePageHeader } from 'src/app/modules/home/shared/components/home-page-header/home-page-header.component';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from 'src/app/shared/components/base-component';

@Component({
  selector: 'app-home-innovation-section-a',
  templateUrl: './home-innovation-section-a.component.html',
  styleUrls: ['./home-innovation-section-a.component.scss']
})
export class HomeInnovationSectionAComponent extends BaseComponent implements OnInit {
  
  innovationHeader : HomePageHeader;
  
  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }

  ngOnInit(): void {
    this.innovationHeader = {
      imgSrc: "assets/images/img_model_01.jpg",
      titleTranslocoKey: "home.rem_innovation.section_a.title",
      descriptionTranslocoKey: "home.rem_innovation.section_a.description"
    };
  }

}
